
import TemplateStandaard from '~/pages/templates/default';
import page from '~/plugins/mixins/page';

export default {
  auth: false,
  components: {
    TemplateStandaard,
  },
  mixins: [page],
};
